var React = require('react');

function GoldenSection0 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M351.678 705C157.441 705 2.62771e-05 547.184 2.62771e-05 352.484C2.62771e-05 157.816 157.441 0 351.678 0L1055 0C1055 389.368 740.119 705 351.71 705","fill":"currentColor"}));
}

GoldenSection0.defaultProps = {"width":"1055","height":"705","viewBox":"0 0 1055 705","fill":"none"};

module.exports = GoldenSection0;

GoldenSection0.default = GoldenSection0;
